<template>
  <div class="drawer-block">
    <BatchSettingModal
      ref="batchSettingModal"
      :classroom-ids="selectList"
      @batchSetSuccess="editSuccess"
    ></BatchSettingModal>
    <div class="drawer-btn" @click.stop="handleOpenDrawer">
      <span>展开同资源商品</span>
    </div>
    <Drawer
      v-model="value1"
      width="536"
      :mask="false"
      title="Basic Drawer"
      :closable="false"
    >
      <div slot="header" class="drawer-header">
        <div class="header-top">
          <span>资源名称：</span>
          <span v-if="orgName">{{ orgName }}</span>
        </div>
        <div class="header-second">
          <span>学校名称</span>
          <span
            v-if="portOrg === 2"
            class="school-name"
          >：{{ userInfo.orgName }}</span>
          <RemoteSelect
            v-else
            v-model="schoolId"
            placeholder="请选择学校"
            :remote-method="remoteGetSchoolList"
            :loading="loadingSchool"
            class="select-width"
            @clear="remoteGetSchoolList('')"
            @visible-change="loadAllList"
          >
            <el-option
              v-for="item in schoolIdList"
              :key="item.orgId"
              :label="item.name"
              :value="item.orgId"
            >
            </el-option>
          </RemoteSelect>
          <Button class="batch-btn" @click="handleSet">批量设置</Button>
        </div>
        <div class="drawer-close-btn" @click.stop="handleCloseDrawer">
          <span>收起</span>
        </div>
      </div>
      <div class="drawer-content">
        <div class="goods-list">
          <CheckboxGroup v-model="selectList">
            <div v-if="currentGoodsInfo" class="goods-list-title">
              课程商品预览
            </div>
            <div v-if="currentGoodsInfo" class="goods-item">
              <Checkbox
                :label="currentGoodsInfo.classroomId"
                class="goods-item-flex"
              >
                <div class="cover-img">
                  <img
                    v-if="
                      currentGoodsInfo.courseCover &&
                        currentGoodsInfo.courseCover !== '0'
                    "
                    :src="
                      downloadUrl + '?fileId=' + currentGoodsInfo.courseCover
                    "
                    alt=""
                  >
                  <img v-else :src="nullImg" alt="">
                </div>
                <div class="item-right">
                  <div class="classroom-name">
                    {{ currentGoodsInfo.classroomName }}
                  </div>
                  <span>{{ currentGoodsInfo.schoolName }}</span>
                  <span>￥{{ currentGoodsInfo.classroomFee / 100 }}</span>
                  <span>{{
                    courseEnrollStateFill[currentGoodsInfo.courseEnrollState]
                  }}</span>
                </div>
              </Checkbox>
            </div>
            <div class="goods-list-title">
              其他课程商品<span v-if="otherTotal">{{ otherTotal }}</span>
            </div>
            <div
              v-for="(item, index) in goodsList"
              :key="index"
              class="goods-item"
            >
              <Checkbox :label="item.classroomId" class="goods-item-flex">
                <div class="cover-img">
                  <img
                    v-if="item.courseCover && item.courseCover !== '0'"
                    :src="downloadUrl + '?fileId=' + item.courseCover"
                    alt=""
                  >
                  <img v-else :src="nullImg" alt="">
                </div>
                <div class="item-right">
                  <div class="classroom-name">{{ item.classroomName }}</div>
                  <span>{{ item.schoolName }}</span>
                  <span>￥{{ item.classroomFee / 100 }}</span>
                  <span>{{
                    courseEnrollStateFill[item.courseEnrollState]
                  }}</span>
                </div>
              </Checkbox>
            </div>
            <div v-if="goodsList.length === 0" class="list-null">
              <img :src="nullImg" alt="">
              <span>没有同资源下的其他课程商品</span>
            </div>
            <Button
              v-if="goodsList.length !== 0 && goodsList.length < total"
              @click="loadMoreGoods"
            >点击加载更多</Button>
          </CheckboxGroup>
        </div>
        <!-- <div v-if="goodsList.length===0&&!currentGoodsInfo" class="goods-list">
          <div class="list-null">
            <img :src="nullImg" alt="">
            <span>没有同资源下的其他课程商品</span>
          </div>
        </div> -->
      </div>
    </Drawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import courseCenterApi from '@/request/courseCenter/index.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import BatchSettingModal from './BatchSettingModal.vue';
import RemoteSelect from '@c/RemoteSelect';
export default {
  components: { BatchSettingModal, RemoteSelect },
  props: {
    orgId: {
      type: String,
      default: ''
    },
    orgName: {
      type: String,
      default: ''
    },
    currentGoodsInfo: {
      type: Object,
      default: () => { }
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value1: false,
      goodsList: [],
      pageNum: 1,
      pageSize: 50,
      total: 0,
      schoolId: -1, // 学校id
      schoolIdList: [], // 学校列表
      selectList: [], // 已选择的classroomid
      nullImg: require('@/assets/img/goods_list_null.png'),
      loadingSchool: false,
      courseEnrollStateFill: ['预报名', '报名中', '已报满', '已截止', '已下架'],
      portOrg: -1
    };
  },
  computed: {
    otherTotal() {
      let totalTrue = 0;
      if (this.currentGoodsInfo) {
        totalTrue = this.total - 1;
      } else {
        totalTrue = this.total;
      }
      return totalTrue > 0 ? `（${totalTrue}个）` : '';
    },
    ...mapState(['userInfo'])
  },
  watch: {
    orgId(newVal) {
      console.log('变化了00000');
      this.judgeOrgId();
    },
    schoolId(newval) {
      this.judgeOrgId();
    }
  },
  mounted() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.judgeOrgId();
    this.remoteGetSchoolList('');
  },
  methods: {
    editSuccess() {
      let index = -1;
      if (this.currentGoodsInfo) {
        index = this.selectList.findIndex(item => {
          return item === this.currentGoodsInfo.classroomId;
        });
      }
      if (index !== -1) {
        this.$emit('resetGoodsInfo');
      }
      this.selectList = [];
      this.goodsList = [];
      this.pageNum = 1;
      this.getCourseList();
    },
    handleSet() {
      console.log(this.selectList, '=====nadaode ------');
      if (this.selectList.length > 0) {
        this.$nextTick(() => {
          this.$refs.batchSettingModal.showModal = true;
        });
      } else {
        this.$Message.error('请至少选择一个！');
      }
    },
    handleOpenDrawer() {
      this.value1 = true;
    },
    handleCloseDrawer() {
      this.value1 = false;
    },
    judgeOrgId() {
      if (this.orgId === '') {
        return;
      }
      this.pageNum = 1;
      this.goodsList = [];
      this.getCourseList();
    },
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList('');
      }
    },
    remoteGetSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      // const queryTrue = query && query.length === 1 ? '' : query;
      const queryTrue = query;
      if (this.portOrg === 0 || this.portOrg === 1) {
        // 运营0和教育局1
        this.getgoodSchoolListFun(queryTrue);
      }
      if (this.portOrg === 3) {
        // 机构

        this.getMechanismSchoolListFun(queryTrue);
      }
    },
    // 搜索框 学校列表 运营端,教育局
    async getgoodSchoolListFun(query) {
      console.log('getgoodSchoolListFun', query);
      const params = {};
      !query ? (params.searchStr = '') : (params.searchStr = query);
      // if (this.searchConds.schoolId) {
      //   params.searchStr = '';
      // }
      const res = await courseCenterApi.getgoodSchoolList(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: '全部学校' }];
        this.schoolIdList = [
          ...arr,
          ...res.message.list
        ];
      }
    },
    // 请求学校列表(机构端)
    async getMechanismSchoolListFun(query) {
      const params = {
        pageNum: 1,
        pageSize: 1000
      };

      !query ? (params.searchStr = '') : (params.searchStr = query);
      // if (this.listParams.schoolId) {
      //   params.searchStr = '';
      // }
      const res = await operationAdmin.getListSchoolsNewAdmin(params);
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: '全部学校' }];
        this.schoolIdList = [
          ...arr,
          ...res.message.list
        ];
      }
      this.loadingSchool = false;
      // this.handleSelectSchHack();
    },
    loadMoreGoods() {
      this.pageNum++;
      this.getCourseList();
    },
    async getCourseList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseId: this.orgId
      };
      this.schoolId && this.schoolId !== -1 ? params.schoolId = this.schoolId : '';
      const res = await courseCenterApi.getgoodsTableList(params);
      if (res.status === 200) {
        this.total = Number(res.message.total);
        const list = res.message.list.map(item => {
          item.imgShow = '';
          return item;
        });
        let index = -1;
        if (this.currentGoodsInfo) {
          index = list.findIndex(item => {
            return item.classroomId === this.currentGoodsInfo.classroomId;
          });
        }
        index !== -1 ? list.splice(index, 1) : '';
        this.goodsList = this.goodsList.concat(list);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.drawer-btn {
  position: fixed;
  right: 0;
  top: 40%;
  margin-top: -85px;
  width: 50px;
  height: 178px;
  background: rgba(0, 0, 0, 0.6);
  box-shadow: -10px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px 0px 0px 10px;
  box-sizing: border-box;
  padding: 16px 18px;
  cursor: pointer;
  z-index: 1000;

  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
  }
}
.drawer-header {
  position: relative;
  padding: 7px 8px;
  .drawer-close-btn {
    position: absolute;
    left: -66px;
    top: 280%;
    width: 50px;
    height: 88px;
    background: rgba(0, 0, 0, 0.6);
    box-shadow: -10px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px 0px 0px 10px;
    box-sizing: border-box;
    padding: 16px 18px;
    cursor: pointer;
    span {
      width: 14px;
      height: 36px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
  }
}
.header-top {
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-bottom: 16px;
  span:nth-of-type(1) {
    font-size: 16px;
    color: #444444;
    line-height: 16px;
  }
  span:nth-of-type(2) {
    font-size: 16px;
    color: #488ffa;
    line-height: 16px;
  }
  span:nth-of-type(3) {
    font-size: 14px;
    color: #666666;
    line-height: 16px;
  }
}
// /deep/.ivu-drawer-body{
//   overflow: visible;
// }
.goods-list-title {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  line-height: 14px;
  padding-left: 9px;
  position: relative;
}
.goods-list-title:before {
  content: '';
  position: absolute;
  width: 4px;
  height: 100%;
  top: 0;
  left: 0;
  background: #488ffa;
}
.header-second {
  display: flex;
  align-items: center;
  .school-name {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #444444;
    line-height: 14px;
  }
  .batch-btn {
    margin-left: auto;
  }
}
.select-width {
  width: 200px;
  margin-left: 8px;
}
.list-null {
  margin: 150px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 180px;
    height: 180px;
  }
  span {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 22px;
  }
}
.goods-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  .goods-item-flex {
    display: flex;
    align-items: center;
  }
  .cover-img {
    width: 120px;
    height: 80px;
    border-radius: 4px;
    margin-left: 22px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .item-right {
    margin-left: 16px;
    flex: 1;
    .classroom-name {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #666666;
      line-height: 20px;
      margin-bottom: 16px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 14px;
    }
    span + span {
      margin-left: 16px;
    }
  }
}
.goods-item + .goods-item {
  border-top: 1px solid #dcdee2;
}
</style>
